import { CommentUI } from './../models/comment';

export type CommentState = CommentUI[];

export const initialState: CommentState = [] as CommentState;
